import { withTranslation } from 'react-i18next'

import App from './App.component'

export default withTranslation()(App)
